<script lang="ts">
    import Button from "../Elements/Button.svelte";
    import {getCdnUrl} from "$lib/cdn";
    import ButtonGroup from "../Elements/ButtonGroup.svelte";
    export let section: Section;
    export let index: number;

    $: imageUrls = section.images.data.map((image) => {

        if (image.attributes.formats?.medium) {
            return  {
                url: image.attributes.formats.medium.url,
                alternativeText: image.attributes.alternativeText
            }
        }

        return {
            url: image.attributes.url,
            alternativeText: image.attributes.alternativeText
        }
    });
</script>

<div class="overflow-hidden bg-white py-32">
    <div class="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
        <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
            <div class="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">

                {#if index === 0}
                    <h1 class="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl font-display">{section.title}</h1>
                {:else}
                    <h2 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl font-display">{section.title}</h2>
                {/if}


                <p class="mt-6 text-xl leading-8 text-gray-600">{section.description}</p>

                {#if section.subDescription}
                    <p class="mt-6 text-base leading-7 text-gray-600">{section.subDescription}</p>
                {/if}

                {#if section.cta.length > 0}
                    <div class="mt-10 flex items-center gap-x-6">
                        <ButtonGroup buttons={section.cta} />
                    </div>
                {/if}
            </div>
            <div class="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                <div class="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                    {#if imageUrls[0]}
                        <img src={getCdnUrl(imageUrls[0].url)} alt={imageUrls[0].alternativeText} class="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover">
                    {/if}
                </div>
                <div class="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                    <div class="order-first flex w-64 flex-none justify-end self-end lg:w-auto">
                        {#if imageUrls[1]}
                            <img src={getCdnUrl(imageUrls[1].url)} alt={imageUrls[1].alternativeText} class="aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover">
                        {/if}
                    </div>
                    <div class="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                        {#if imageUrls[2]}
                            <img src={getCdnUrl(imageUrls[2].url)} alt={imageUrls[2].alternativeText} class="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover">
                        {/if}
                    </div>
                    <div class="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                        {#if imageUrls[3]}
                            <img src={getCdnUrl(imageUrls[3].url)} alt={imageUrls[3].alternativeText} class="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover">
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
